import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import { ErrorMessage, Field, FormikProvider, useFormik } from 'formik';
import { Button, Col, Form, InputGroup, Row } from 'react-bootstrap';
import moment from 'moment';
import { ALPHABETS_DOT_ONLY, ALPHABETS_DOT_ONLY_Msg, ERROR_MSG, handleInputToUppercase, handleKeyAlphaNumeric, handleKeyPressAlphabetsDot, handleKeyPressNumeric, Mobile_Msg, MOBILE_VALIDATION } from '../CommonUtilities/Validations/RegularExpAndVar';
import { config } from '../CommonUtilities/CommonUrl/CommonUrls';
import { CommonPageHeading } from '../CommonUtilities/CommonHeading/CommonPageHeading';
import { IoIosArrowRoundDown } from 'react-icons/io';
import axios from 'axios';
import { TfiReload } from 'react-icons/tfi';
import { CommonReactTable } from '../CommonUtilities/CommonTable/CommonReactTable';


export default function TetResultsPrevious() {
    const [showData, setData] = useState([]);
    const [showD1, setD1] = useState();
    const [showErrsg, setErrMsg] = useState("");

    // **********************columns *************************
    const columns = [
        { Header: "S.NO", accessor: (row, index) => index + 1 },
        { Header: "HallTicket No", accessor: "ht_no" },
        { Header: "Candidate Name", accessor: "candidate_name" },
        { Header: "Father Name", accessor: "father_name" },
        { Header: "Subject", accessor: "tet_post_name" },
        { Header: "Year Of Pass", accessor: "yop" },
        { Header: "Score", accessor: "score" },
    ]

    const [refreshCaptcha, setRefreshCaptcha] = useState("");
        const handleRefreshCaptcha = () => {
            Formik.setFieldValue('captchaId', "")
            Formik.setFieldValue('captcha', "")
            let url = config.url.CONTEXT_URL + "kgbv-public/generate-captcha";
            axios.post(url).then((res) => {
                if (res?.data?.status === true) {
                    setRefreshCaptcha(res.data.captcha)
                    Formik.setFieldValue('captchaId', res.data.captchaId)
                }
            })
        };

    function isBackFunction() {
        setD1(showD1 - 1);
    }
    useEffect(() => { handleRefreshCaptcha() }, [])
    // *************validations ************************
    const userValidations = Yup.object().shape({
        searchField: Yup.string().required(ERROR_MSG).nullable(),
        captcha: Yup.string().required(ERROR_MSG),
        // aadharNo: Yup.string().when("searchField", {
        //     is: "aadhar", then: (schema) => schema.required(ERROR_MSG)
        //         .matches(AADHAR_VALIDATION, Aadhaar_Msg)
        //         .test("isValid", Aadhaar_Msg, function (value) {
        //             if (value) {
        //                 return validateVerhoeff(value);
        //             }
        //             return true;
        //         }),
        //     otherwise: (schema) => schema.nullable(),
        // }),

        mobileNo: Yup.string().when("searchField", {
            is: "mobileNo",
            then: (schema) => schema.required(ERROR_MSG).nullable().matches(MOBILE_VALIDATION, Mobile_Msg),
            otherwise: (schema) => schema.nullable(),
        }),

        htNo: Yup.string().when("searchField", {
            is: "htNo",
            then: (schema) => schema.required(ERROR_MSG).max(20, "Max 20 characters allowed").nullable(),
            otherwise: (schema) => schema.nullable(),
        }),

        candidateName: Yup.string().when("searchField", {
            is: "other",
            then: (schema) =>
                schema
                    .required(ERROR_MSG).min(3, "Minimum 3 characters required").max(50, "Maximum 50 characters allowed")
                    .nullable().matches(ALPHABETS_DOT_ONLY, ALPHABETS_DOT_ONLY_Msg),
            otherwise: (schema) => schema.nullable(),
        }),

        fatherName: Yup.string().when("searchField", {
            is: "other",
            then: (schema) =>
                schema
                    .required(ERROR_MSG).min(3, "Minimum 3 characters required").max(50, "Maximum 50 characters allowed")
                    .nullable().matches(ALPHABETS_DOT_ONLY, ALPHABETS_DOT_ONLY_Msg),
            otherwise: (schema) => schema.nullable(),
        }),

        dob: Yup.string().when("searchField", {
            is: "other",
            then: (schema) =>
                schema.required(ERROR_MSG).nullable(),
            otherwise: (schema) => schema.nullable(),
        }),
    });


    const Formik = useFormik({
        initialValues: {
            searchField: "",
            captcha: "",
            captchaId: "",
            mobileNo: "",
            htNo: "",
            candidateName: "",
            fatherName: "",
            dob: ""
        },
        validationSchema: userValidations,
        onSubmit: (values) => {
            setD1(0);
            //  console.log("val>>", values);
            let url = config.url.CONTEXT_URL + "kgbv-public/candidate-personal-and-paper-details";
            axios.post(url, values).then((res) => {
                if (res?.data?.status === true) {
                    setData(res?.data?.data);
                    setErrMsg("");
                }
                else {
                    handleRefreshCaptcha();
                    Formik.setFieldValue("captcha", "");
                    setData([]);
                    setErrMsg(res?.data?.sdesc);
                }

            })
        }
    })
    return (
        <React.Fragment>
            <FormikProvider value={Formik}>
                <Form className="form-section mb-4" onSubmit={Formik.handleSubmit} onChange={Formik.handleChange}>
                    <div className='px-4'>
                        <CommonPageHeading heading="Previous TET Results" back={false} />
                        <Row className="row px-3">
                            <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3">
                                <div className="input-div position-relative">
                                    <Form.Group controlId="searchField" >
                                        <Form.Label className="input-lable mb-3">Select By Search<font color="red">*</font></Form.Label>
                                        <Field as="select" className="input-field form-control" name='searchField'
                                            onChange={(e) => {
                                                // Formik.setFieldValue("aadharNo", "");
                                                Formik.setFieldValue("mobileNo", "");
                                                Formik.setFieldValue("htNo", "");

                                                Formik.setFieldValue("candidateName", "");
                                                Formik.setFieldValue("fatherName", "");
                                                Formik.setFieldValue("dob", "");
                                                Formik.setFieldValue("captcha", "");
                                                handleRefreshCaptcha();
                                                setData([]);
                                                setErrMsg("");
                                                setD1(undefined);
                                            }}
                                        >
                                            <option value="">--Select--</option>
                                            {/* <option value="aadhar">Aadhaar No</option> */}
                                            <option value="mobileNo">Mobile No</option>
                                            <option value="htNo">TET Hallticket No</option>
                                            <option value="other">Candidate Name,Father Name,DOB</option>
                                        </Field>
                                        <ErrorMessage name="searchField" component="div" className="text-error" />
                                    </Form.Group>
                                    <IoIosArrowRoundDown className="dropdown-icon" />
                                </div>
                            </Col>

                            {/* {Formik?.values?.searchField === "aadhar" &&
                                <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3 mt-2">
                                    <Form.Group controlId="aadharNo">
                                        <Form.Label className="input-lable mb-2"> Aadhaar No<font color="red">*</font> </Form.Label>
                                        <Field type="text" name="aadharNo" className="input-field form-control" maxLength="12"
                                            onKeyPress={(e) => {
                                                handleKeyPressNumeric(e);
                                            }}
                                        />
                                    </Form.Group>
                                    <ErrorMessage name="aadharNo" component="div" className="text-error" />
                                </Col>
                            } */}

                            {Formik?.values?.searchField === "mobileNo" &&
                                <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3 mt-2">
                                    <Form.Group controlId="mobileNo">
                                        <Form.Label className="input-lable mb-2"> Mobile No<font color="red">*</font> </Form.Label>
                                        <Field type="text" name="mobileNo" className="input-field form-control" maxLength="10"
                                            onKeyPress={(e) => { handleKeyPressNumeric(e); }}
                                        />
                                    </Form.Group>
                                    <ErrorMessage name="mobileNo" component="div" className="text-error" />
                                </Col>
                            }

                            {Formik?.values?.searchField === "htNo" &&
                                <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3 mt-2">
                                    <Form.Group controlId="htNo">
                                        <Form.Label className="input-lable mb-2"> TET Hallticket No<font color="red">*</font> </Form.Label>
                                        <Field type="text" name="htNo" className="input-field form-control" maxLength="20"
                                            onKeyPress={(e) => { handleKeyAlphaNumeric(e); }}
                                            onInput={(e) => { handleInputToUppercase(e) }}
                                        />
                                    </Form.Group>
                                    <ErrorMessage name="htNo" component="div" className="text-error" />
                                </Col>
                            }


                            {Formik?.values?.searchField === "other" &&
                                <React.Fragment>
                                    <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3 mt-2">
                                        <Form.Group controlId="candidateName">
                                            <Form.Label className="input-lable mb-2"> Candidate Name<font color="red">*</font> </Form.Label>
                                            <Field type="text" name="candidateName" className="input-field form-control" minLength="3" maxLength="50"
                                                onKeyPress={(e) => { handleKeyPressAlphabetsDot(e); }}
                                                onInput={(e) => { handleInputToUppercase(e) }}
                                            />
                                        </Form.Group>
                                        <ErrorMessage name="candidateName" component="div" className="text-error" />
                                    </Col>

                                    <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3 mt-2">
                                        <Form.Group controlId="htNo">
                                            <Form.Label className="input-lable mb-2"> Father Name<font color="red">*</font></Form.Label>
                                            <Field type="text" name="fatherName" className="input-field form-control" maxLength="50" minLength="3"
                                                onKeyPress={(e) => {
                                                    handleKeyPressAlphabetsDot(e);
                                                }}
                                                onInput={(e) => { handleInputToUppercase(e) }}
                                            />
                                        </Form.Group>
                                        <ErrorMessage name="fatherName" component="div" className="text-error" />
                                    </Col>

                                    <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3 mt-2">
                                        <Form.Group controlId="htNo">
                                            <Form.Label className="input-lable mb-2"> DOB<font color="red">*</font> </Form.Label>
                                            <Field type="date" name="dob" className="input-field form-control" max={moment().format("YYYY-MM-DD")} />
                                        </Form.Group>
                                        <ErrorMessage name="dob" component="div" className="text-error" />
                                    </Col>
                                </React.Fragment>
                            }
                             <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3 pt-4">
                                                            <Form.Group controlId="captcha">
                                                                <InputGroup className="mb-2">
                                                                    <TfiReload onClick={() => { handleRefreshCaptcha() }} size={20} className="mt-2" />&nbsp;
                                                                    <img height={40} width={100} src={refreshCaptcha} alt="captcha" />&nbsp;&nbsp;
                                                                    <Field className="form-control" type="text" name="captcha" placeholder="Captcha" maxLength="6" autoComplete="off" />
                                                                </InputGroup>
                                                            </Form.Group>
                                                            <ErrorMessage name="captcha" component="div" className="text-error" />
                                                        </Col>
                        </Row>
                        <div className='d-flex justify-content-end align-items-center pb-2'>
                            <Button type="submit" className="btn btn-primary btn-md"> Get Data </Button>
                        </div>
                        {/* <div className='d-flex justify-content-between align-items-center pb-2'>
                            <div className='text-start text-danger px-3' style={{ fontSize: "16px" }}>
                                Note : Please enter at least one detail to proceed
                            </div>

                            <Button type="submit" className="btn btn-primary btn-md"> Get Data </Button>
                        </div> */}
                        {showD1 === 0 && (
                            <> {showData?.length > 0 ? (
                              
                                    <CommonReactTable pagination="false" data={showData} columns={columns}
                                        serachAlign="left" isBack={false}
                                        isBackFunction={isBackFunction}
                                        headerName={<>Previous TET Results</>}
                                        headColumCount={7} search="true" showFooter="false" filename="TetResult"
                                        paginationCount="All" printFalg="false"

                                    /> 
                            ) : (
                                <div className="text-error text-center" style={{ fontSize: "15px" }}>{showErrsg}</div>)}</>)}

                    </div>
                </Form>
            </FormikProvider>
        </React.Fragment>
    )
}
